import React, { ChangeEvent } from 'react';
import { useAppSelector } from '../../../store/hooks/StoreHooks';

interface TextareaProps {
    value: string;
    name?: string;
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    label?: string;
    rows?: number;
    cols?: number;
    maxLength?: number;
    disabled?: boolean;
    error?: string;
    isResizable?: boolean;
    hasOverflow?: boolean;
}

const Textarea: React.FC<TextareaProps> = ({
    value,
    name,
    onChange,
    placeholder = "Enter text...",
    label,
    rows = 4,
    cols = 50,
    maxLength,
    disabled = false,
    error,
    isResizable = true,
    hasOverflow = false,
}) => {

    const { customerEnabled, customerCreated } = useAppSelector((state) => state.auth);
    const { projectReadOnly } = useAppSelector((state) => state.projectHeader);

    return (
        <>
            {
                <div className="flex flex-col gap-[6px]">
                    {label && <label className='flex flex-row justify-start items-start text-neutral-25'>{label}</label>}
                    <textarea
                        value={value}
                        name={name}
                        onChange={(e) => { onChange(e); }}
                        placeholder={placeholder}
                        rows={rows}
                        cols={cols}
                        maxLength={maxLength}
                        disabled={disabled || (customerEnabled && !customerCreated) || projectReadOnly}
                        className={`border-darkcolor-400 border-[1px] py-[12px] px-[14px] rounded-[8px] text-neutral-25 bg-darkcolor-700 p-[16px] focus:outline-none focus:ring-1 focus:ring-darkcolor-700 ${(disabled || (customerEnabled && !customerCreated)) ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : 'hover:border-primary-500 focus:ring-primary-500 focus-within:ring-1 focus-within:border-primary-500'
                            } ${error ? 'border-red-500' : ''}`}
                        style={{
                            resize: isResizable ? 'both' : 'none',
                            overflowY: hasOverflow ? 'auto' : 'hidden',
                            maxHeight: '200px',
                            minHeight: '80px',
                            width: '100%'
                        }}
                    />
                    {error && <p className="text-error-500 text-sm">{error}</p>}
                </div>
            }
        </>

    );
};

export default Textarea;
